import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppRootState} from '../appStore';
import {WorkspaceGetAllResponse} from 'models/workspace.model';

export interface workspaceState {
    workspaces: WorkspaceGetAllResponse[];
    selectedWorkSpace?: WorkspaceGetAllResponse;
    selectedWorkSpaceSlug?: string;
}

let initialState: workspaceState = {
    workspaces: [],
};

export const workSpaceSlice = createSlice({
    name: 'WorkSpace',
    initialState,
    reducers: {
        addWorkSpaces: (state, action: PayloadAction<WorkspaceGetAllResponse[]>) => {
            state.workspaces = action.payload;
        },
        setSelectedWorkSpace: (state, action: PayloadAction<WorkspaceGetAllResponse>) => {
            state.selectedWorkSpace = action.payload;
        },
        removeWorkspace: (state, action: PayloadAction<string>) => {
            state.workspaces = state.workspaces.filter(workspace => workspace.id !== action.payload);
        },
    },
});

export const {removeWorkspace, addWorkSpaces, setSelectedWorkSpace} = workSpaceSlice.actions;

export const workSpaceSliceReducer = workSpaceSlice.reducer;
export const workSpaceSelector = (rootState: AppRootState): workspaceState => rootState.workSpaces;
